// Mapping of Excel header cells to user data fields
export const excelHeaderCellsName = {
  "رقم المعرف": "id",
  عنوان: "title",
  المحتوى: "body",
  المفتاح: "key",
  نشط: "isActive",
};
